
import { Component, Vue } from 'vue-property-decorator'
import lsPagination from "@/components/ls-pagination.vue";
import { RequestPaging } from '@/utils/util'
import LsDialog from "@/components/ls-dialog.vue";
import {apiTagDel, apiTagList, apiTagEdit, apiTagGroupList} from '@/api/operating/group_welfare/tag'
@Component({
  components: {
    lsPagination,
    LsDialog
  }
})
export default class PointLabel extends Vue {
  /** S Data*/
  pager: RequestPaging = new RequestPaging();
  active = 'all'
  query:any = {
    name: '',
  }
  form:any = {
  
  }
  rules = {
    parent_id: [
      {required: true, message: '请选择标签分组', trigger: 'change'}
    ],
    name: [
      {required: true, message: '请输入标签名称', trigger: 'blur'}
    ]
  }
  groupList = []
  dialogShow = false
  /** E Data*/
  /** S Methods*/
  getGroupList() {
    apiTagGroupList({}).then(res => {
      this.groupList = res.lists
    })
  }
  getList(page?: number) {
    page && (this.pager.page = page);
    this.pager.request({
      callback: apiTagList,
      params: {
        ...this.query,
      },
    });
  }
  edit(row:any) {
    this.form = {
      id: row.id,
      parent_id: row.parent_id,
      name: row.name,
      sort: row.sort
    }
    this.dialogShow = true
  }
  add() {
    this.form = {
      sort: 0
    }
    this.dialogShow = true
  }
  submit() {
    const refs = this.$refs['form'] as HTMLFormElement
    refs.validate((valid: boolean): any => {
      if (!valid) return
      apiTagEdit(this.form).then(res => {
        this.getList(1);
        this.dialogShow = false
      })
    })
  }
  del(row:any) {
    apiTagDel({id: row.id}).then(res => {
      this.getList(1)
    })
  }
  /** E Methods*/
  /** S ods **/
  created() {
    this.getGroupList()
    this.getList();
  }
}
